export default {
  screens: [
    {
      type: 'intro',
      title: '情感艺匠',
      content: 'CHAUMET借助源源不断的创造力，表达对生命的喜悦和爱意。',
      idYt: '9RbWHsnfvK0',
      videoCover: 'world/sentimental/video.jpg',
      desktop: {
        cover: 'world/sentimental/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sentimental/mobile-cover-1.jpg',
        contentStyle: { width: '100%' },
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '-27%',
          right: '0',
          left: '0',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/sentimental/perspectiveLeft.jpg',
      middleImg: 'world/sentimental/perspectiveMiddle.jpg',
      rightImg: 'world/sentimental/perspectiveRight.jpg',
      content:
        '全新“结”作，诠释最自由激情的缘分。它将轻盈俏皮的诱惑重新塑造，如丝带般缠绕交织，打造绮丽幻想。',
      cover: 'world/sentimental/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        cover: 'world/sentimental/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        rightImg: 'world/sentimental/perspectiveRight.jpg',
        cover: 'world/sentimental/mobile-cover-1.jpg',
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '0',
          left: '-18%',
          position: 'absolute'
        }
      },
      content:
        '“连结”符号自1780年CHAUMET珠宝世家创建之初就被创造，它是情感珠宝悠久传统的一部分，是友谊、爱和承诺的象征。 '
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cn/worlds/sentimental.js